<template>
  <div v-if="loading" class="loader">
    <div class="loading-wrap">
      <div class="loading-elem"></div>
    </div>
  </div>
</template>

<script>
import { useShowSpinner } from "@/helpers/showSpinner";
export default {
  setup() {
    return useShowSpinner();
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/global-variables";
.loader {
  background: rgba(255, 255, 255, 0.7);
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  z-index: 9;
  width: 100%;
}
.loading-wrap {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate3d(-50%, -50%, 0);
}
.loading-elem,
.loading-elem:after {
  border-radius: 50%;
  width: 8em;
  height: 8em;
  z-index: 99;
}
.loading-elem {
  margin: 60px auto;
  font-size: 10px;
  position: relative;
  text-indent: -9999em;
  border-top: 1em solid rgb(118, 182, 168, 0.8);
  border-right: 1em solid rgb(118, 182, 168, 0.8);
  border-bottom: 1em solid rgb(118, 182, 168, 0.8);
  border-left: 1em solid rgba(255, 255, 255, 0.4);
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-animation: load8 1.1s infinite linear;
  animation: load8 1.1s infinite linear;
}
@-webkit-keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>
